import DOMPurify from "dompurify";

export const sanitize = (htmlString: string): string => {
  return DOMPurify.sanitize(htmlString, {
    ALLOWED_TAGS: [
      "p",
      "br",
      "strong",
      "b",
      "i",
      "u",
      "em",
      "ul",
      "ol",
      "li",
      "h1",
      "h2",
      "h3",
      "a",
      "table",
      "thead",
      "tbody",
      "tr",
      "th",
      "td",
      "div",
    ],
    ALLOWED_ATTR: ["href", "title", "target", "rel"],
  });
};
